import React from 'react';

import { SkeletonProfileImage, SkeletonBody } from '@xingternal/skeleton';

import styles from './Skeleton.css';

const ContactsSkeleton = () => (
  <div className={styles.contactsWrapper}>
    <div className={styles.profileImage}>
      <SkeletonProfileImage />
    </div>
    <div className={styles.profileInfo}>
      <SkeletonBody variant="primary" amountRows={3} />
    </div>
  </div>
);

export default ContactsSkeleton;
